const mwPrefix = '../mw';
const snPrefix = '../sn';

function buildPath(path, sn) {
	const prefix = sn ? snPrefix : mwPrefix;
	return {
		url: `${prefix}${path}`,
	};
}

module.exports = {

	/**
     *   Prefix path for root
     */
	prefix: '',

	// Core URLs
	/**
     * Core web services urls
     * @property lock
     */
	core: {

		/**
         * lock entity url
         * @property url
         */

		async_search_attributes: buildPath('/request/attributes/dict'),

		// moved
		sn_alive_request: {
			url: `${snPrefix}/server/alive`,
		},

		// moved
		phone_conf: {
			url: `${snPrefix}/phone/conf`,
		},

		// moved
		sse_auth: {
			url: `${snPrefix}/CallEvent/auth`,
		},

		// moved
		phone_register: {
			url: `${mwPrefix}/operator/set`,
		},

		sse_stream: {
			url: `${snPrefix}/CallEvent/stream`,
		},
		sse_client_log: {
			url: `${snPrefix}/CallEvent/client-log`,
		},

		// moved
		dialog_answer: {
			url: `${snPrefix}/Dialog/answer`,
		},

		// moved
		dialog_hangup: {
			url: `${snPrefix}/Dialog/drop`,
		},

		// moved
		dialog_hold: {
			url: `${snPrefix}/Dialog/hold`,
		},

		// moved
		dialog_retrieve: {
			url: `${snPrefix}/Dialog/retrieve`,
		},

		// moved
		dialog_call: {
			url: `${snPrefix}/Dialog/call`,
		},

		// moved
		dialog_transfer: {
			url: `${snPrefix}/Dialog/transfer`,
		},

		// moved
		operator_status: {
			url: `${mwPrefix}/admin/state/list`,
		},

		// moved
		set_operator_status: {
			url: `${mwPrefix}/admin/state/set`,
		},

		// moved
		article_delete: {
			url: `${mwPrefix}/kb/delete`,
		},

		// moved
		get_appeal_actions: {
			url: `${mwPrefix}/appeal_label/action/list`,
		},

		// moved
		set_appeal_action: {
			url: `${mwPrefix}/appeal/action/params`,
		},

		// moved
		customer: {
			url: `${mwPrefix}/customer`,
		},

		// moved
		create_individual_customer: {
			url: `${mwPrefix}/customer/create/individual`,
		},

		// moved
		create_organization: {
			url: `${mwPrefix}/customer/create/organization`,
		},

		// moved
		customer_address_type: {
			url: `${mwPrefix}/address/type/list`,
		},

		// moved
		customer_edit: {
			url: `${mwPrefix}/customer/edit`,
		},

		// moved
		customer_edit_multi: {
			url: `${mwPrefix}/customer/edit/mult`,
		},

		// moved
		customer_persons: {
			url: `${mwPrefix}/customer/person`,
		},

		// moved
		person: {
			url: `${mwPrefix}/person`,
		},

		// moved
		person_unlink: {
			url: `${mwPrefix}/customer/person/unlink`,
		},

		// moved
		person_edit: {
			url: `${mwPrefix}/customer/person/edit`,
		},

		// moved
		issues_edit: {
			url: `${mwPrefix}/customer/person/issues/save`,
		},

		// moved
		person_edit_multi: {
			url: `${mwPrefix}/customer/person/edit/mult`,
		},

		// moved
		person_save_contact: {
			url: `${mwPrefix}/person/contact/save`,
		},

		// moved
		person_delete_contact: {
			url: `${mwPrefix}/person/contact/delete`,
		},

		// unused
		person_contact: {
			url: `${mwPrefix}/person/contact`,
		},

		// unused
		person_link: {
			url: `${mwPrefix}/person/link`,
		},

		// unused
		persons_save: {
			url: `${mwPrefix}/customer/person/save`,
		},

		// used - \src\pages\Customer\TabContent.js  `customer_${data.subTab}`
		customer_appeals: {
			url: `${mwPrefix}/appeal/customer`,
		},

		// unused
		customer_appeals_info: {
			url: `${mwPrefix}/appeal/customer/info`,
		},

		// moved
		customer_address: {
			url: `${mwPrefix}/customer/addresses`,
		},

		// moved
		customer_consultation: {
			url: `${mwPrefix}/appeal/customer?consultation=1`,
		},

		// moved
		customer_history_change: {
			url: `${mwPrefix}/customer/audit`,
		},

		// unused
		customer_services: {
			url: `${mwPrefix}/customer/services`,
		},

		// moved
		customer_services_types: {
			url: `${mwPrefix}/customer/services/type/list`,
		},

		// unused
		customer_accounts: {
			url: `${mwPrefix}/customer/accounts`,
		},

		// unused
		// // the same url as "customer_accounts"
		customer_contracts: {
			url: `${mwPrefix}/customer/accounts`,
		},

		// unused
		customer_info: {
			url: `${mwPrefix}/customer/info`,
		},

		// moved
		customer_bank: {
			url: `${mwPrefix}/customer/bank`,
		},

		// moved
		applicants_search: {
			url: `${mwPrefix}/CallHistory/search`,
		},

		// unused
		customer_suggest: {
			url: `${mwPrefix}/CallHistory/search`,
		},

		// unused
		call_history: {
			url: `${mwPrefix}/CallHistory/phone`,
		},

		// moved
		user_info: {

			// return info about current user
			url: `${mwPrefix}/auth`,
		},

		// unused
		user_get_phones_list: {
			url: `${mwPrefix}/user/get/phones/list`,
		},

		// moved
		user_edit_phones_list: {
			url: `${mwPrefix}/user/edit/phones/list`,
		},

		not_auth: {

			// server not_authenticated (for redirect)
			url: `${mwPrefix}/auth/not_auth`,
			redirect_url() {
				return `${this.url}?next=${encodeURI(window.location.href)}`;
			},
		},

		// unused
		profile: {
			url: '../api/auth/profile',
			redirect: true,
		},

		// moved
		logout: {
			url: `${mwPrefix}/auth/logout_idm`,
			redirect: true,
		},

		// unused
		titles_menu: {
			url: '/data/precrmEntities.json',
		},

		// moved
		apps_menu: {
			url: '/data/applications.json',
		},

		// unused
		local_customer: {
			url: '/data/customer.json',
		},

		// unused
		local_appeal: {
			url: '/data/appeal.json',
		},

		// unused
		local_task: {
			url: '/data/task.json',
		},

		// moved
		dictionary: {
			url: `${mwPrefix}/app/dictionaries`,
		},

		// moved
		search: {
			url: `${mwPrefix}/search`,
		},

		// moved
		search_csv: {
			url: `${mwPrefix}/search/csv`,
		},

		// moved
		appeal_interaction_csv: {
			url: `${mwPrefix}/appeal/progress/interactions/csv`,
		},

		// moved
		appeal_customer_csv: {
			url: `${mwPrefix}/appeal/customer/csv`,
		},

		// moved
		filters: {
			url: `${mwPrefix}/request/presets`,
		},

		// moved
		appeal_filters: {
			url: `${mwPrefix}/request/templates`,
		},

		// moved
		filter_fields: {
			url: `${mwPrefix}/request/filter`,
		},

		// moved
		filter_apply: {
			url: `${mwPrefix}/request/filter/apply`,
		},

		// unused
		filter_apply_native: {
			url: `${mwPrefix}/request/filter/native`,
		},

		// moved
		preset_apply: {
			url: `${mwPrefix}/request/preset/apply`,
		},

		// moved
		preset_apply_csv: {
			url: `${mwPrefix}/request/filter/apply/csvOneStep`,
		},

		// moved
		preset_apply_export_to_csv: {
			url: `${mwPrefix}/request/filter/apply/csvexport`,
		},

		// moved
		preset_apply_export_to_xlsx: {
			url: `${mwPrefix}/request/filter/apply/xlsxexport`,
		},

		// moved
		attributes: {
			url: `${mwPrefix}/request/attributes`,
		},

		// moved
		save_filter: {
			url: `${mwPrefix}/request/preset/save`,
		},

		// moved
		info_filter: {
			url: `${mwPrefix}/request/preset/info`,
		},

		// moved
		delete_filter: {
			url: `${mwPrefix}/request/filter/delete`,
		},

		// unused
		knowledge_base_tree: {
			url: `${mwPrefix}/kb/tree`,
		},

		// moved
		knowledge_base: {
			url: `${mwPrefix}/kb/list`,
		},

		// moved
		kb_status_list: {
			url: `${mwPrefix}/kb/status/list`,
		},

		// moved
		kb_detail: {
			url: `${mwPrefix}/kb/detail`,
		},

		// moved
		knowledge_base_save: {
			url: `${mwPrefix}/kb/save`,
		},

		// moved
		comments: {
			url: `${mwPrefix}/appeal/comment`,
		},

		// moved
		// Update comment text.
		comment_update: {
			url: `${mwPrefix}/appeal/comment/update`,
			method: 'post',
		},

		// moved
		// Attach file to comment.
		comment_attach: {
			url: `${mwPrefix}/appeal/comment/attach`,
		},

		// moved
		// Detach file from comment.
		comment_detach: {
			url: `${mwPrefix}/appeal/comment/detach`,
		},

		// unused
		download_file: {
			url: `${mwPrefix}/file`,
		},

		// moved
		delete_file: {
			url: `${mwPrefix}/file/delete`,
		},

		// moved
		save_file: {
			url: `${mwPrefix}/file/upload`,
		},

		// moved
		// Delete file
		file_delete: {
			url: `${mwPrefix}/appeal/file/delete`,
		},

		// unused
		// // Get all files attached to comment
		file_list: {
			url: `${mwPrefix}/appeal/file/list`,
		},

		// duplicate
		comment_add: {
			url: `${mwPrefix}/appeal/comment`,
		},

		// moved
		upload_file: {
			url: `${mwPrefix}/appeal/file/upload`,
		},

		// moved
		upload_file_email: {
			url: `${mwPrefix}/email/attach/upload`,
		},

		// moved
		delete_file_email: {
			url: `${mwPrefix}/email/attach/delete`,
		},

		// moved
		get_files_list: {
			url: `${mwPrefix}/email/attach/list`,
		},

		// unused
		interaction_create: {
			url: `${mwPrefix}/interaction/create`,
		},

		// moved
		interaction_close: {
			url: `${mwPrefix}/interaction/close`,
		},

		// moved
		interaction_appeal: {
			url: `${mwPrefix}/interaction/appeal`,
		},

		// moved
		appeal_create: {
			url: `${mwPrefix}/interaction/appeal/create`,
		},

		// moved
		appeal_save: {
			url: `${mwPrefix}/interaction/appeal/save`,
		},

		// unused
		appeal_interactions: {
			url: `${mwPrefix}/appeal/interactions`,
		},

		// moved
		appeal_interaction_proof: {
			url: `${mwPrefix}/appeal/interactions/proof`,
		},

		// moved
		appeal_type: {
			url: `${mwPrefix}/appeal/filteredType`,
		},

		// moved
		appeal_form_params: {
			url: `${mwPrefix}/form/params`,
		},

		appeal_form_ajax: {
			url: `${mwPrefix}/form/values/search`,
		},

		// moved
		appeal_by_id: {
			url: `${mwPrefix}/appeal`,
		},

		// moved
		get_appeal_version: {
			url: `${mwPrefix}/appeal/version`,
		},

		// moved
		appeal_status_list: {
			url: `${mwPrefix}/appeal/status/list`,
		},

		// moved
		appeal_dest_list: {
			url: `${mwPrefix}/appeal/dest/list`,
		},

		// moved
		appeal_priority_list: {
			url: `${mwPrefix}/appeal/priority/list`,
		},

		// moved
		appeal_feedback: {
			url: `${mwPrefix}/appeal/contactPersons`,
		},

		// moved
		appeal_feedback_save: {
			url: `${mwPrefix}/appeal/contacts/save`,
		},

		// unused
		// appeal_customer_save: {
		// 	url: `${mwPrefix}/interaction/customer/save`,
		// },

		// moved
		unlock_appeal_form: {
			url: `${mwPrefix}/appeal/lock`,
		},

		// moved
		unlock_appeal: {
			url: `${mwPrefix}/appeal/unlock`,
		},

		// unused
		appeal_update: {
			url: `${mwPrefix}/appeal/update`,
		},

		// unused
		appeal_timer_save: {
			url: `${mwPrefix}/appeal/timer/save`,
		},

		// moved
		mailing: {
			url: `${mwPrefix}/email/inbox/short`,
		},

		// moved
		send_email: {
			url: `${mwPrefix}/email/reply`,
		},

		// moved
		forward_email: {
			url: `${mwPrefix}/email/forward`,
		},

		// moved
		get_template_list: {
			url: `${mwPrefix}/notificationTemplate/list`,
		},

		// moved
		get_template_email: {
			url: `${mwPrefix}/notificationTemplate/test`,
		},

		// moved
		create_new_email: {
			url: `${mwPrefix}/email/create`,
		},

		// moved
		history: {
			url: `${mwPrefix}/appeal/progress/interactions/list`,
		},

		// moved
		interaction: {
			url: `${mwPrefix}/interaction/create`,
		},

		// moved
		task: {
			url: `${mwPrefix}/order/task`,
		},

		// unused
		callhistory_list: {
			url: `${mwPrefix}/order/task/filter/list`,
		},

		// unused
		doc_template_default: {
			url: `${mwPrefix}/doctempl/default`,
		},

		// moved
		doc_template_create: {
			url: `${mwPrefix}/request/document/make`,
		},

		// unused
		doc_download: {
			url: `${mwPrefix}/doctempl/file`,
		},

		doc_download_direct: {
			url: `${mwPrefix}/request/document/download`,
		},

		// moved
		search_settlement: {
			url: `${mwPrefix}/geo/settlement`,
		},

		// moved
		search_settlement_by_zip_code: {
			url: `${mwPrefix}/geo/zip/search`,
		},

		// moved
		search_street: {
			url: `${mwPrefix}/geo/street`,
		},

		// moved
		add_street: {
			url: `${mwPrefix}/addresses/street/add`,
		},

		// moved
		search_building: {
			url: `${mwPrefix}/geo/build`,
		},

		// moved
		search_zip_code: {
			url: `${mwPrefix}/geo/zip`,
		},

		// moved
		quality_questions_list: {
			url: `${mwPrefix}/interaction/item/type/list`,
		},

		// unused
		quality_questions: {
			url: `${mwPrefix}/interaction/item/rows`,
		},

		// moved
		dashboard_templates: {
			url: `${mwPrefix}/dashboard/templates`,
		},

		// moved
		dashboard_filter: {
			url: `${mwPrefix}/dashboard/filter`,
		},

		// moved
		dashboard_kpi: {

			// url:  'data/dashboard/summary.json'
			url: `${mwPrefix}/dashboard/appealkpi`,
		},

		// moved
		dashboard_map: {
			url: `${mwPrefix}/dashboard/filter/interactappealmap`,
		},

		// moved
		dashboard_pie: {

			// url:  'data/dashboard/pieChart.json'
			url: `${mwPrefix}/dashboard/filter/appealtoptenq`,
		},

		// moved
		dashboard_line: {

			// url:  'data/dashboard/lineChart.json'
			url: `${mwPrefix}/dashboard/filter/appealcount`,
		},

		// moved
		dashboard_statuses_by_destination: {
			url: `${mwPrefix}/dashboard/filter/apealstatusesbydest`,
		},

		// moved
		dashboard_statuses_by_type: {
			url: `${mwPrefix}/dashboard/filter/apealstatusesbytype`,
		},

		// moved
		dashboard_appeal_top_ten_by_dest: {
			url: `${mwPrefix}/dashboard/filter/appealtoptendest`,
		},

		// moved
		dashboard_appeal_top_ten_by_oper: {
			url: `${mwPrefix}/dashboard/filter/appealtoptenoper`,
		},

		// moved
		get_blank_html: {
			url: `${mwPrefix}/request/document/getDocument`,
		},

		// Settings.

		// moved
		admin_user_all: {
			url: `${mwPrefix}/admin/user/all`,
		},

		// moved
		admin_group_all: {
			url: `${mwPrefix}/admin/group/all`,
		},

		// moved
		admin_area_all: {
			url: `${mwPrefix}/admin/area/list`,
		},

		// moved
		admin_domain_all: {
			url: `${mwPrefix}/admin/space/list`,
		},

		// moved
		admin_access_rules: {
			url: `${mwPrefix}/admin/space/rules`,
		},

		// moved
		add_access_rule: {
			url: `${mwPrefix}/admin/space/rule/add`,
		},

		// moved
		delete_access_rule: {
			url: `${mwPrefix}/admin/space/rule/del`,
		},

		// moved
		add_child_access_rule: {
			url: `${mwPrefix}/admin/child/rule/add`,
		},

		// moved
		delete_child_access_rule: {
			url: `${mwPrefix}/admin/child/rule/del`,
		},

		// moved
		get_access_rule_tables: {
			url: `${mwPrefix}/admin/space/table/list`,
		},

		// moved
		get_access_rule_columns: {
			url: `${mwPrefix}/admin/space/column/list`,
		},

		// moved
		get_access_rule_conditions: {
			url: `${mwPrefix}/admin/space/condition/list`,
		},

		// moved
		get_rule_access: {
			url: `${mwPrefix}/admin/space/rule/info`,
		},

		// moved
		get_child_rule_access: {
			url: `${mwPrefix}/admin/child/rules`,
		},

		// moved
		save_rule_access: {
			url: `${mwPrefix}/admin/space/rule/set`,
		},

		// moved
		get_group_domains: {
			url: `${mwPrefix}/admin/user/space/list`,
		},

		// moved
		add_user_group: {
			url: `${mwPrefix}/admin/area/add`,
		},

		// moved
		delete_user_group: {
			url: `${mwPrefix}/admin/area/del`,
		},

		// Settings/BuissnesUnits
		// moved
		get_buisness_units: {
			url: `${mwPrefix}/order/task/bu/list`,
		},

		// moved
		delete_buisness_unit: {
			url: `${mwPrefix}/order/task/bu/del`,
		},

		// moved
		add_buisness_unit: {
			url: `${mwPrefix}/order/task/bu/add`,
		},

		// moved
		edit_buisness_unit: {
			url: `${mwPrefix}/order/task/bu/set`,
		},

		// moved
		get_buisness_unit_users: {
			url: `${mwPrefix}/order/task/bu/emp/list`,
		},

		// moved
		search_buisness_unit_user: {
			url: `${mwPrefix}/order/task/bu/emp/search`,
		},

		// moved
		delete_buisness_unit_user: {
			url: `${mwPrefix}/order/task/bu/emp/del`,
		},

		// moved
		add_buisness_unit_user: {
			url: `${mwPrefix}/order/task/bu/emp/set`,
		},

		// moved
		get_buisness_unit_spaces: {
			url: `${mwPrefix}/space/list`,
		},

		// unused
		get_buisness_unit_spaces_all: {
			url: `${mwPrefix}/space/all`,
		},

		// moved
		search_buisness_unit_space: {
			url: `${mwPrefix}/space/all`,
		},

		// moved
		add_buisness_unit_space: {
			url: `${mwPrefix}/space/add`,
		},

		// moved
		delete_buisness_unit_space: {
			url: `${mwPrefix}/space/del`,
		},

		// moved
		get_buisness_unit_restrs: {
			url: `${mwPrefix}/admin/space/restr`,
		},

		// moved
		get_buisness_unit_restr: {
			url: `${mwPrefix}/admin/space/restr/info`,
		},

		// moved
		get_buisness_unit_restr_types: {
			url: `${mwPrefix}/admin/space/attr/restr`,
		},

		// moved
		edit_buisness_unit_restr: {
			url: `${mwPrefix}/admin/space/restr/set`,
		},

		// moved
		delete_buisness_unit_restr: {
			url: `${mwPrefix}/admin/space/restr/del`,
		},

		// moved
		sync_buisness_unit_users: {
			url: `${mwPrefix}/admin/user/sync`,
		},

		// moved
		sync_buisness_unit_domains: {
			url: `${mwPrefix}/admin/domain/sync`,
		},

		// Orders

		// unused
		get_order_list: {
			url: `${mwPrefix}/order/task`,
		},

		// unused
		get_order_csv: {
			url: `${mwPrefix}/form/params/csv`,
		},

		// unused
		get_order_type_options: {
			url: `${mwPrefix}/order/task/type/list`,
		},

		// unused
		create_new_order: {
			url: `${mwPrefix}/order/task/new?version=111-`,
		},

		// unused
		get_public_orders_filters: {
			url: `${mwPrefix}/order/task/filter/list`,
		},

		// unused
		get_private_orders_filters: {
			url: `${mwPrefix}/order/search/filters/list`,
		},

		// unused
		get_order_comments: {
			url: `${mwPrefix}/order/task/comment`,
		},

		// unused
		get_order_params: {
			url: `${mwPrefix}/order/task/row/params`,
		},

		// unused
		get_order_history_all: {
			url: `${mwPrefix}/changes`,
		},

		// unused
		get_order_history_system: {
			url: `${mwPrefix}/changes/system`,
		},

		// unused
		get_order_comments_users_emails: {
			url: `${mwPrefix}/order/task/comment/email/user/search`,
		},

		// unused
		get_order_comments_email_history: {
			url: `${mwPrefix}/order/task/comment/email/get`,
		},

		// unused
		get_order_actions: {
			url: `${mwPrefix}/order/task/actions`,
		},

		// unused
		set_order_action: {
			url: `${mwPrefix}/order/task/action`,
		},

		// unused
		track_order: {
			url: `${mwPrefix}/track`,
		},

		// unused
		get_order_suspend_reason_list: {
			url: `${mwPrefix}/order/task/suspend/reason/list`,
		},

		// unused
		get_sub_orders: {
			url: `${mwPrefix}/order/task/subtasks/`,
		},
	},
};
